export const COPY_CHART_REQUEST = "COPY_CHART_REQUEST";
export const COPY_CHART_SUCCESS = "COPY_CHART_SUCCESS";
export const COPY_CHART_FAILURE = "COPY_CHART_FAILURE";
